import { Component, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SpinnerService } from 'shared-components';
import { environment } from 'projects/packcert-web/src/environments/environment';
import { SessionContextService } from '../../../../context/session-context.service';
import { AdminService } from '../../../admin/services/admin.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { CultivosService } from '../../services/cultivos.service';

@Component({
    selector: 'app-edicion-poligonos',
    templateUrl: './app-edicion-poligonos.component.html'
})
export class EdicionPoligonosComponent implements OnInit {

    public mapURL: SafeResourceUrl;
    public entidadControlId;
    public toCloseSpinner = 0;

    private isAppReady = false;
    private paramsAlreadySent = false;
    private gisParams: any = {};

    constructor(
        private readonly _cultivosService: CultivosService,
        private readonly _router: Router,
        private readonly _adminService: AdminService,
        private readonly _sessionContext: SessionContextService,
        private readonly _spinnerService: SpinnerService,
        private readonly _translate: TranslateService,
        private readonly _sanitizer: DomSanitizer) {
    }

    @HostListener('window:message', ['$event'])
    handleGisMessage(event: MessageEvent) {
        if (event.origin !== environment.denominacionGisEdicion) {
        return;
        }

        if (event.data?.type === 'editor-ready') {
        this.isAppReady = true;

        if ((this._sessionContext.sessionUser.role === 'Auditor' &&
            this.entidadControlId) ||
            (this._sessionContext.sessionUser.role !== 'Auditor')
        ) {
            this.sendGisParams();
        }
        }
    }

    ngOnInit() {
        this.mapURL = this._sanitizer.bypassSecurityTrustResourceUrl(environment.denominacionGisEdicion);
        this.getGisParams();

        if (this._sessionContext.sessionUser.role === 'Auditor') {
            const promises: Promise<any>[] = [];
            promises.push(this.getEntidadControl());

            Promise.all(promises).then(
                () => {
                    if (this.isAppReady) {
                        this.sendGisParams();
                    }
                }, (error) => {
                    console.log('Promise rejected with ' + JSON.stringify(error));
                }
            ).catch(e => console.log(e));
        } else {
            if (this.isAppReady) {
                this.sendGisParams();
            }
        }
        
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public getEntidadControl(): Promise<any> {
        return new Promise((resolve, reject) => {
            let filters = {
                userName: this._sessionContext.sessionUser.userName
            };
            this._spinnerService.showSpinner();
            this._adminService.getEntidadesControl(filters).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this.entidadControlId = resp.lista[0].id;
                    // Mandamos también ID de auditor y estilos personalizados
                    this.gisParams.userData.entidadControlId = this.entidadControlId;
                    this.gisParams.customStyles = localStorage.getItem('customStyles') || null;
                }
                setTimeout(resolve, 1);
            });
        });
    }

    private checkCloseSpinner() {
      this.toCloseSpinner -= 1;
      if (this.toCloseSpinner === 0) {
          this._spinnerService.hideSpinner();
      }
    }

    public openDocHelp() {
      this._spinnerService.showSpinner();
      this.toCloseSpinner += 1;
      this._cultivosService.getDocHelp('Crops_Polygon_Editing.pdf').toPromise().finally(() => {
          this.checkCloseSpinner();
      }).then((resp) => {
          localStorage.setItem('base64', resp.base64Archivo);
          const url = this._router.serializeUrl(this._router.createUrlTree(['viewPdf']));
          window.open(url, '_blank');
      });
    }

    /**
    * Obtener los parámetros comunes a Auditor y admin
    */
    private getGisParams() {
        this.gisParams = {
            userData: {
                app: 'CUL',
                token: this._sessionContext.sessionUser.token,
                rol: this._sessionContext.sessionUser.role,
                locale: this._translate.getDefaultLang(),
                permisoIns: this._sessionContext.sessionUser.role === 'Administrador' || this.claims.includes('DSH_PoligonoCultivo_Ins'),
                permisoUpd: this._sessionContext.sessionUser.role === 'Administrador' || this.claims.includes('DSH_PoligonoCultivo_Upd'),
                permisoLoad: this._sessionContext.sessionUser.role === 'Administrador'
            },
        };
    }

    private sendGisParams() {
        if (!this.paramsAlreadySent) {
            const iframe = document.querySelector('iframe');
            iframe?.contentWindow?.postMessage(
                {
                    type: 'gis-params',
                    payload: this.gisParams,
                },
                environment.denominacionGisEdicion
            );

            this.paramsAlreadySent = true;
        }
    }

}

